export type TableId = string;

export type Table = {
  name: string;
  id: TableId;
  columnNames: string[];
  rows: string[][];
};

/** @returns a markdown compliant table */
export function formatTable(t: Table) {
  const columnWidths = t.columnNames.map((name, idx) => {
    let width = name.length;
    t.rows.forEach(row => {
      const value = row[idx];
      if (value.length > width) {
        width = value.length;
      }
    });
    return width;
  });

  const lines = [
    // header
    t.columnNames.map((name, i) => name.padEnd(columnWidths[i])),
    columnWidths.map(width => '-'.repeat(width)),
    // body
    ...t.rows.map(row => row.map((value, i) => `${value}`.padEnd(columnWidths[i]))),
  ];

  return lines
    .map(
      words =>
        words.length > 1
          ? words.join(' | ') /** normal case markdown table */
          : '| ' + words.join('') /** edge case: single column markdown table */,
    )
    .join('\n');
}
